import axios from 'axios'
import { awsConfig, commonConfig } from './config'

axios.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error
    const { status, data } = response
    if (status === 400 && data.Message.includes('ExpiredTokenException')) {
      window.location.href = `${awsConfig.cognitoDomain}/logout?client_id=${awsConfig.clientId}&logout_uri=${commonConfig.domain}`
    }
    return Promise.reject(error)
  },
)

export default axios
